import React from "react";

import { FormSectionElements } from "../../../entities/formTemplateDataType";
import { DEFAULT_PLATE_CHARACTERS, renderPlateImage } from "../../../utilities/custom/PlpUtils";
import FormValidationUtils from "../../../utilities/FormValidationUtils";
import { getFieldByName } from "../../../utilities/ElementUtils";
import {OrderInfoArea, OrderPriceArea} from "./OrderBreakdownComponent-style"
import './OrderBreakdownComponent.css';
import { GroupItem, NameValuePair } from "./models";

interface Props {
  field: FormSectionElements;
  isEng: boolean;
}

const getProductsPayment = (field): {
      products: GroupItem[],
      payment: { itemEntriesEn: NameValuePair[], itemEntriesFr: NameValuePair[], subTotalEntriesEn: NameValuePair[], subTotalEntriesFr: NameValuePair[], totalEntriesEn: NameValuePair[], totalEntriesFr: NameValuePair[]}
  }  => {
  const sectionElement = getFieldByName('orderItemDetails', field);
  
  if (sectionElement) {
    return sectionElement.Value;
  }
  return null;
}

const plateImageHtml = (index: number, plateType: string, sloganLanguage: string, graphicType: string, plateCharacters?: string): React.JSX.Element => {
  const html = <>
      <div id={`plate-image-summary-` + index} style={{marginTop: '16px', marginBottom: '16px', marginRight: '76px'}}></div>
  </>;

  renderPlateImage(plateType, sloganLanguage, graphicType, plateCharacters || DEFAULT_PLATE_CHARACTERS, index);

  return html;
}

const getProductSectionTitle = (field, isEng) => {
  if (isEng) {
    return field.OrderBreakdownConfig?.productSectionTitle || "Items ordered and related fees";
  } else {
    return field.OrderBreakdownConfig?.productSectionTitleFRA || "Articles commandés et frais connexes";
  }
}

const findEntry = (list: NameValuePair[], name: string) => {
  return list.find((entry) => entry.name === name);
}

/**
 * A generic component to display the order-info breakdown.
 * @param param0 
 * @returns 
 */
const OrderInfoBreakdownComponent = ({field, isEng}: Props) => {
  FormValidationUtils.runJavascript(field);

  const orderBreakdown = getProductsPayment(field);
  if (!field.OrderBreakdownConfig?.showPlateImage && orderBreakdown) {
    let index = 0;
    orderBreakdown.products?.map((product) => {
      product.items.map((item) => {
        if (item.additionalProperties?.length) {
          item.htmlElement = plateImageHtml(index++, findEntry(item.additionalProperties, 'plateType')?.value, findEntry(item.additionalProperties, 'sloganLanguage')?.value, findEntry(item.additionalProperties, 'graphicType')?.value, findEntry(item.additionalProperties, 'plateCharacters')?.value);
        }
      })   
    })
  }

  return (
    <>
      <br/>
      <OrderPriceArea>
          <OrderInfoArea products={orderBreakdown?.products} payment={orderBreakdown?.payment} className={'product-card'} title={getProductSectionTitle(field, isEng)} isEng={isEng} />
      </OrderPriceArea>
    </>
  );
}

export default OrderInfoBreakdownComponent;